import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { 
  Layout, 
  Breadcrumb, 
  Row, 
  Col, 
  Card, 
  Select, 
  Button, 
  Input, 
  Form, 
  Divider, 
  message,
  Empty
} from "antd";
import Sidebar from "../../layout/Sidebar";
import Navbar from "../../layout/Navbar";
import { getAllMenus, createMenu, updateMenu, deleteMenu } from "../../../actions/ecommercemenuAction";
import MenuManager from "./MenuManager";

const { Content } = Layout;
const { Option } = Select;

const MenuIndex = ({ getAllMenus, createMenu, updateMenu, deleteMenu }) => {
  const [menus, setMenus] = useState([]);
  const [selectedMenuId, setSelectedMenuId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [newMenuName, setNewMenuName] = useState("");
  const [currentMenuName, setCurrentMenuName] = useState("");

  useEffect(() => {
    fetchMenus();
  }, []);

  const fetchMenus = async () => {
    setLoading(true);
    const data = await getAllMenus();
    if (data) {
      setMenus(data);
      if (data.length > 0 && !selectedMenuId) {
        setSelectedMenuId(data[0].id);
        setCurrentMenuName(data[0].name);
      }
    }
    setLoading(false);
  };

  const handleSelectMenu = (id) => {
    setSelectedMenuId(id);
    const menu = menus.find(m => m.id === id);
    setCurrentMenuName(menu?.name || "");
  };

  const handleCreateMenu = async () => {
    if (!newMenuName) return;
    const data = await createMenu({ name: newMenuName });
    if (data) {
      setNewMenuName("");
      message.success("Menu created successfully");
      fetchMenus();
      setSelectedMenuId(data.id);
      setCurrentMenuName(data.name);
    }
  };

  const handleUpdateMenuName = async () => {
    if (!currentMenuName || !selectedMenuId) return;
    const data = await updateMenu(selectedMenuId, { name: currentMenuName });
    if (data) {
      message.success("Menu name updated");
      fetchMenus();
    }
  };

  return (
    <Layout className="window-frame">
      <Sidebar />
      <Layout className="site-layout">
        <Navbar />
        <Content className="main-frame-content">
          <Breadcrumb style={{ margin: "16px 0" }}>
            <Breadcrumb.Item>Ecommerce</Breadcrumb.Item>
            <Breadcrumb.Item>Menu Management</Breadcrumb.Item>
          </Breadcrumb>
          <div className="site-layout-background main-frame">
            <Card title="Menu Management" style={{ marginBottom: 20 }}>
              <Row gutter={16} align="middle">
                <Col span={6}>
                  <Select 
                    style={{ width: '100%' }} 
                    placeholder="Select a menu to edit"
                    value={selectedMenuId}
                    onChange={handleSelectMenu}
                  >
                    {menus.map(menu => (
                      <Option key={menu.id} value={menu.id}>{menu.name}</Option>
                    ))}
                  </Select>
                </Col>
                <Col span={6}>
                  <Input 
                    placeholder="New menu name" 
                    value={newMenuName} 
                    onChange={e => setNewMenuName(e.target.value)} 
                    onPressEnter={handleCreateMenu}
                  />
                </Col>
                <Col span={4}>
                  <Button type="primary" onClick={handleCreateMenu}>Create</Button>
                </Col>
                <Divider type="vertical" />
                {selectedMenuId && (
                  <>
                    <Col span={5}>
                      <Input 
                        value={currentMenuName} 
                        onChange={e => setCurrentMenuName(e.target.value)} 
                        placeholder="Current Menu Name"
                      />
                    </Col>
                    <Col span={2}>
                      <Button onClick={handleUpdateMenuName}>Update</Button>
                    </Col>
                  </>
                )}
              </Row>
            </Card>

            {selectedMenuId ? (
              <MenuManager 
                menuId={selectedMenuId} 
                refreshMenus={fetchMenus}
              />
            ) : (
              <Card>
                <Empty description="Select a menu or create a new one to start managing items." />
              </Card>
            )
            }
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default connect(null, { getAllMenus, createMenu, updateMenu, deleteMenu })(MenuIndex);
